import React, { useContext } from "react";
import styles from "./BannerContainer.module.scss";
import { Context } from "../Store";

const BannerContainer = () => {
  const [state] = useContext(Context);
  const country = state.country;

  const isUK = country === "uk"; 
  const desktopSrc = isUK ? "./img/FC_Your Stories_Wide Website Banner_V1_Uk.webp" : "./img/FC_Your Stories_Wide Website Banner_V1.webp";
  const mobileSrc = isUK ? "./img/FC_Your Stories_2-1 Website Banner_Uk.webp" : "./img/FC_Your Stories_2-1 Website Banner.webp";

  return (
    <div className="section section--padded">
      <div className={styles.BannerContainer}>
        <a href={`https://flightclubdarts.com/flightclub10/your-memories`} target="_blank">
          <img className={styles.BannerDesk} src={desktopSrc} alt="Flight Club Game 7" />
          <img className={styles.BannerMob} src={mobileSrc}  alt="Flight Club Game 7" />
        </a>
      </div>
    </div>
  );
};

export default BannerContainer;
